import { action, computed, observable } from 'mobx';
import { version } from 'mobx-sync';
import { getUserLanguage, Language, Locale } from '~web/i18n';
import { BaseStore } from '~web/store/base/base-store';

@version(2)
export class UserPreferencesStore extends BaseStore {
  @observable locale: Locale;
  @observable showTransactionInstructions: boolean;
  @observable showDrawTutorial: boolean;
  @observable showAuctionTutorial: boolean;
  @observable showMarketTutorial: boolean;
  @observable showPriceTutorial: boolean;
  @observable streamingSkipPreWaiting: boolean;

  constructor() {
    super();
    this.clear();
  }

  @action
  hideTransactionInstructions(): void {
    this.showTransactionInstructions = false;
  }

  @action
  hideDrawTutorial(): void {
    this.showDrawTutorial = false;
  }

  @action
  hideAuctionTutorial(): void {
    this.showAuctionTutorial = false;
  }

  @action
  hideMarketTutorial(): void {
    this.showMarketTutorial = false;
  }

  @action
  hidePriceTutorial(): void {
    this.showPriceTutorial = false;
  }

  @computed
  get language(): Language {
    return getUserLanguage();
  }

  @action
  setLocale(locale: Locale): void {
    this.locale = locale;
  }

  clear(): void {
    this.locale = undefined;
    this.showTransactionInstructions = true;
    this.showDrawTutorial = true;
    this.showAuctionTutorial = true;
    this.showMarketTutorial = true;
    this.showPriceTutorial = true;
    this.streamingSkipPreWaiting = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/user-preferences-store.ts